import type { StatisticCardConfig } from "@ms/shared-components";

// 统计卡片显示配置
export const STATISTIC_CONFIG = {
  // 列数
  COLUMNS: 4,
  // 样式
  STYLE: { marginBottom: 0 },
} as const;

/**
 * 统计数据配置
 * 用于生成统计卡片的配置数据
 */
export const createStatisticData = (statistics: {
  total: number;
  withIcon: number;
  withColor: number;
  withDescription: number;
}): StatisticCardConfig[] => [
  {
    key: "total",
    title: "总标签数",
    value: statistics.total,
    iconKey: "FileTextOutlined",
    valueStyle: { color: "#1890ff" },
  },
  {
    key: "withIcon",
    title: "带图标标签",
    value: statistics.withIcon,
    iconKey: "ToolOutlined",
    valueStyle: { color: "#52c41a" },
  },
  {
    key: "withColor",
    title: "带颜色标签",
    value: statistics.withColor,
    iconKey: "CheckCircleOutlined",
    valueStyle: { color: "#faad14" },
  },
  {
    key: "withDescription",
    title: "带描述标签",
    value: statistics.withDescription,
    iconKey: "ExclamationCircleOutlined",
    valueStyle: { color: "#722ed1" },
  },
];
